"use client"
import type { Persona } from "@opensea/navigation"
import { ToggleButtonGroup, ToggleButtonGroupItem } from "@opensea/ui-kit"
import { useTranslations } from "next-intl"
import { usePersonaSwitch } from "@/hooks/use-persona-switch"
import { Sound, usePlaySound } from "@/hooks/use-play-sound"

export function PageFooterPersonaToggle() {
  const { persona, setPersona } = usePersonaSwitch()
  const [playSelect] = usePlaySound(Sound.Select)
  const t = useTranslations("PageFooterPersonaToggle")

  return (
    <ToggleButtonGroup
      onValueChange={value => {
        setPersona(value as Persona)
        playSelect()
      }}
      size="sm"
      value={persona}
    >
      <ToggleButtonGroupItem value="collector">
        {t("collector")}
      </ToggleButtonGroupItem>
      <ToggleButtonGroupItem value="advanced">{t("pro")}</ToggleButtonGroupItem>
    </ToggleButtonGroup>
  )
}
